import { CSSProperties } from 'react';

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  rounded?: 'none' | 'sm' | 'md' | 'full';
  className?: string;
  style?: CSSProperties;
  ariaLabel?: string;
}

const radiusMap = {
  none: '0',
  sm: '4px',
  md: '8px',
  full: '9999px'
} as const;

/**
 * Generic content placeholder. Reduces CLS while content is loading.
 * Matches the dark amber theme; override via className when a route needs
 * different styling.
 */
export default function Skeleton({ width, height, rounded = 'md', className = '', style, ariaLabel }: SkeletonProps) {
  const widthValue = typeof width === 'number' ? `${width}px` : width || '100%';
  const heightValue = typeof height === 'number' ? `${height}px` : height || '1rem';
  return (
    <span
      role={ariaLabel ? 'status' : undefined}
      aria-label={ariaLabel}
      aria-live={ariaLabel ? 'polite' : undefined}
      className={`inline-block animate-pulse bg-zinc-800 ${className}`}
      style={{
        width: widthValue,
        height: heightValue,
        borderRadius: radiusMap[rounded],
        ...style
      }}
    />
  );
}
